import React from "react";
import styled from "styled-components";
import { useAppState } from "../shared/ContextProvider";
import NoCardFound from "./card-components/NoCardFound";
import { useData } from "../shared/DataProvider";
import Card from "../components/card-components/Card";
import { DataState } from "../shared/DataProvider";

const AllCardWrapper = styled.div`
  display: grid;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;
  row-gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(366px, 1fr));
`;

const SyledContainer = styled.div`
  width: 100%;
  height: auto;
`;

export default function Cards() {
  const { state } = useAppState();
  const { loading, data } = useData();

  if (loading) {
    return (
      <SyledContainer>
        <NoCardFound />
      </SyledContainer>
    );
  }

  if (state.consulting) {
    const filteredData = data.filter(
      (eachCard) => eachCard.status === "상담중"
    );

    return (
      <AllCardWrapper>
        {filteredData?.map((eachCard, index) => {
          if (state.consulting) {
            const newState: DataState = [];
            eachCard.status === "상담중" && newState.push(eachCard);
            console.log("NEW_STATE", newState);
          }

          return (
            <Card
              key={index}
              id={eachCard.id}
              title={eachCard.title}
              client={eachCard.client}
              due={eachCard.due}
              count={eachCard.count}
              amount={eachCard.amount}
              status={eachCard.status}
              method={eachCard.method}
              material={eachCard.material}
            />
          );
        })}
      </AllCardWrapper>
    );
  }

  // array1.length === array2.length && array1.every((value, index) => value === array2[index])

  if (state.milling && state.shelf) {
    const array2compare = ["밀링", "선반"];
    const filteredData = data.filter(
      (eachCard) =>
        eachCard.method.length === array2compare.length &&
        eachCard.method.every((value, i) => value === array2compare[i])
    );

    return (
      <AllCardWrapper>
        {filteredData?.map((eachCard, index) => {
          if (state.consulting) {
            const newState: DataState = [];
            eachCard.status === "상담중" && newState.push(eachCard);
            console.log("NEW_STATE", newState);
          }

          return (
            <Card
              key={index}
              id={eachCard.id}
              title={eachCard.title}
              client={eachCard.client}
              due={eachCard.due}
              count={eachCard.count}
              amount={eachCard.amount}
              status={eachCard.status}
              method={eachCard.method}
              material={eachCard.material}
            />
          );
        })}
      </AllCardWrapper>
    );
  }

  if (state.milling) {
    const array2compare = ["밀링"];
    const filteredData = data.filter(
      (eachCard) =>
        eachCard.method.length === array2compare.length &&
        eachCard.method.every((value, i) => value === array2compare[i])
    );

    return (
      <AllCardWrapper>
        {filteredData?.map((eachCard, index) => {
          if (state.consulting) {
            const newState: DataState = [];
            eachCard.status === "상담중" && newState.push(eachCard);
            console.log("NEW_STATE", newState);
          }

          return (
            <Card
              key={index}
              id={eachCard.id}
              title={eachCard.title}
              client={eachCard.client}
              due={eachCard.due}
              count={eachCard.count}
              amount={eachCard.amount}
              status={eachCard.status}
              method={eachCard.method}
              material={eachCard.material}
            />
          );
        })}
      </AllCardWrapper>
    );
  }

  if (state.shelf) {
    const array2compare = ["선반"];
    const filteredData = data.filter(
      (eachCard) =>
        eachCard.method.length === array2compare.length &&
        eachCard.method.every((value, i) => value === array2compare[i])
    );

    return (
      <AllCardWrapper>
        {filteredData?.map((eachCard, index) => {
          if (state.consulting) {
            const newState: DataState = [];
            eachCard.status === "상담중" && newState.push(eachCard);
            console.log("NEW_STATE", newState);
          }

          return (
            <Card
              key={index}
              id={eachCard.id}
              title={eachCard.title}
              client={eachCard.client}
              due={eachCard.due}
              count={eachCard.count}
              amount={eachCard.amount}
              status={eachCard.status}
              method={eachCard.method}
              material={eachCard.material}
            />
          );
        })}
      </AllCardWrapper>
    );
  }
  return (
    <AllCardWrapper>
      {data?.map((eachCard, index) => {
        if (state.consulting) {
          const newState: DataState = [];
          eachCard.status === "상담중" && newState.push(eachCard);
          console.log("NEW_STATE", newState);
        }

        return (
          <Card
            key={index}
            id={eachCard.id}
            title={eachCard.title}
            client={eachCard.client}
            due={eachCard.due}
            count={eachCard.count}
            amount={eachCard.amount}
            status={eachCard.status}
            method={eachCard.method}
            material={eachCard.material}
          />
        );
      })}
    </AllCardWrapper>
  );
}
